import gql from 'graphql-tag';

const BEST_VERBATIM = gql`
  query getBestReportingVerbatimCardData(
    $projectId: Int!
    $range: DateRangeInput!
    $criteriaKeys: [CriteriaKey!]
    $thematics: [ThematicInput!]
  ) {
    getVerbatimGlobalBestAndPainPointsCardData(
      projectId: $projectId
      range: $range
      criteriaKeys: $criteriaKeys
      thematics: $thematics
    ) {
      bestVerbatim {
        id
        kpis {
          eindex {
            value
          }
        }
        verbatim {
          verbatimFullText
          verbatimSentences {
            sentence
            relevantThematic
          }
        }
      }
    }
  }
`;

export default BEST_VERBATIM;
